

export default class Crosshair {

    constructor(comp) {

        this.comp = comp
        this.$p = comp.$props
        this.data = this.$p.sub
        this._visible = false
        this.locked = false
        this.layout = this.$p.layout

    }

    draw(ctx) {
        // Update reference to the grid
        this.layout = this.$p.layout

        const cursor = this.comp.$props.cursor
        if (!this.visible || !Number.isFinite(cursor.x) || !Number.isFinite(cursor.y)) return

        this.x = this.$p.cursor.x
        this.y = this.$p.cursor.y

        ctx.save()
        const mode=this.$p.drawingPrefs?.cursor || 'cross';
        if(mode!=='cross'){
            ctx.fillStyle=this.$p.colors.cross;ctx.font='22px sans-serif';
            if(mode==='dot'){ctx.beginPath();ctx.arc(this.x,this.y,3,0,Math.PI*2);ctx.fill()}
            else if(mode==='demonstration'||mode==='magic'){
                const now=Date.now();this.trail=(this.trail || []).filter(p=>now-p.time<700);
                const last=this.trail[this.trail.length-1];
                if(!last||last.x!==this.x||last.y!==this.y)this.trail.push({x:this.x,y:this.y,time:now});
                for(const p of this.trail){ctx.globalAlpha=.6*(1-(now-p.time)/700);if(mode==='magic')ctx.fillText('✦',p.x,p.y);else{ctx.beginPath();ctx.arc(p.x,p.y,9,0,Math.PI*2);ctx.fill()}}
                clearTimeout(this.fadeTimer);if(this.trail.length)this.fadeTimer=setTimeout(()=>this.comp.$emit('redraw-grid'),40);
            }
            else ctx.fillText(mode==='eraser'?'⌫':'↖',this.x,this.y);
            ctx.restore();return;
        }
        ctx.strokeStyle = this.$p.colors.cross
        ctx.beginPath()
        ctx.setLineDash([5])

        // H
        if (this.$p.cursor.grid_id === this.layout.id) {
            ctx.moveTo(0, this.y)
            ctx.lineTo(this.layout.width - 0.5, this.y)
        }

        // V
        ctx.moveTo(this.x, 0)
        ctx.lineTo(this.x, this.layout.height)
        ctx.stroke()
        ctx.restore()

    }

    destroy() { clearTimeout(this.fadeTimer) }

    hide() {
        this.visible = false
        this.x = undefined
        this.y = undefined
    }

    get visible() {
        return this._visible
    }

    set visible(val) {
        this._visible = val
    }

}
